import React, { Component } from 'react';
import "./Resume.css";

class Linq3 extends Component {
   render() {
      return (
         <div className="Linq3">
            <h1 className="text-center section-heading">Linq3 9/18 - 2/19</h1>
            <hr/>
            <p>My duties at Linq3 included debugging and developing in C on 
               BSD Unix platforms in a microservices architecture system. 
               My work primarily was socket programming in a client-server 
               environment.
            </p>
         </div>
      );
   }
} 

export default Linq3;





// WEBPACK FOOTER //
// ./src/components/Resume/Linq3.js